import folderStore from 'owa-folders';
import { action, select } from 'satcheljs/lib/legacy';
import viewStateStore from '../store/store';
import setFolderViewExpansionState from '../actions/setFolderViewExpansionState';
export var initiateMailFolderTextField = select({
    folderTable: function () { return folderStore.folderTable; },
    viewState: function () { return viewStateStore; },
})(action('initiateMailFolderTextField')(function initiateMailFolderTextField(folderId, operation, state) {
    if (operation === 'new') {
        setFolderViewExpansionState(folderId, true);
    }
    state.viewState.folderTextFieldViewState = {
        folderId: folderId,
        operation: operation,
    };
}));
export var dismissMailFolderTextField = select({
    viewState: function () { return viewStateStore; },
})(action('dismissMailFolderTextField')(function dismissMailFolderTextField(state) {
    state.viewState.folderTextFieldViewState = null;
}));
//# sourceMappingURL=folderTextFieldActions.js.map